export function chunkArray<T>(arr: Array<T>, size: number) {
  return Array.from(
    { length: Math.ceil(arr.length / size) },
    (_: any, i: number) => arr.slice(i * size, i * size + size),
  )
}

export function waitFor(condFn: () => boolean) {
  const poll = (resolve: () => void) => {
    if (condFn()) {
      resolve()
    } else {
      setTimeout(() => poll(resolve), 100)
    }
  }
  return new Promise<void>(poll)
}

// RFC 5322 compliant regex for email validation
export const validateEmail = (email: string): boolean => {
  // The control characters are part of RFC 5322: they are the escapable range
  // permitted inside a quoted local-part. Narrowing the class to satisfy
  // no-control-regex would reject addresses the spec allows.
  const re =
    // eslint-disable-next-line no-control-regex
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

  return re.test(email)
}
